import { Component, OnInit } from '@angular/core';
import { CommonApiService } from 'src/app/services/common-api.service';
import { first } from 'rxjs/operators';
import * as moment from "moment";
import * as $ from "jquery"
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  pincode: any;
  edit: boolean = true;
  save: boolean = false;
  displayName: any;
  email: any;
  profile: any;
  created: any;
  loader: boolean = false;
  bot: any;
  emailcheck: boolean = false;
  constructor(public api: CommonApiService) { }



  ngOnInit(): void {
    this.loader = true;
    this.getCurrentUser()
  }

  getCurrentUser() {
    this.api.getUserData().pipe(first()).subscribe(res => {
      this.profile = res;
      this.created = moment(res['created']).format('LL');
      this.bot = res['meters']
      console.log(this.created);

      this.loader = false

    })
  }

  editProfile() {
    this.save = true;
    this.edit = false
  }

  saveProfile() {
    console.log("enter");
    
    // this.loader = true
    // let formdata = {
    //   "displayName": this.profile.displayName,
    //   "email": this.profile.email
    // }

    // var email_reg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    // var emailinput = $('#emailId').val();
    // console.log(emailinput);


    // if (email_reg.test(emailinput) == true) {
    //   this.api.userUpdate(formdata).pipe(first()).subscribe(res => {
    //     this.loader = false;
    //     this.getCurrentUser()
    //     this.save = false;
    //     this.edit = true;

    //   })
    // } else {
    //   this.loader = false;
    //   this.emailcheck = true;
    // }


  }

}
